module.exports = __webpack_public_path__ + "static/media/pay_now.b145b248.png";